import {School} from './web-components/models/school';
import {GlobalFunction} from '../common/core/global_function';
import {SchoolService} from '../common/services/school.service';
import {AcademicService} from '../common/services/academic.service';
import {AdmintableComponent} from './web-components/shared/admin_table.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AppGlobal} from '../common/app.global';
import {Location} from '@angular/common';
import {ViewChild} from '@angular/core';
import {MatSelect} from '@angular/material';

export class AdminTableEvaluationBaseComponent extends AdmintableComponent {

  academicYears: any[] = [];
  selectedYear: any = '';

  listSchools: School[] = [];
  originSchools: any[] = [];
  selectedSchools: any[] = [];

  public idMap: any = [];
  public sequenceNo = 0;

  defaultSchoolText = 'School';
  placeHolderSchool = 'School';
  order_default: any = 'lastmoddate desc';

  activePage = 0;
  recordTitle = '';

  @ViewChild('formClassSelection')
  private formClassSelection: MatSelect;
  placeHolderFormClass = 'Form/Class';
  defaultFormClass = 'All';
  selectedAllFormClass = true;
  formClassOptions: string[] = ['All', '1A', '1B', '1C', '1D', '1E', '1F',
    '2A', '2B', '2C', '2D', '2E', '2F',
    '3A', '3B', '3C', '3D', '3E', '3F',
    '4A', '4B', '4C', '4D', '4E', '4F',
    '5A', '5B', '5C', '5D', '5E', '5F',
    '6A', '6B', '6C', '6D', '6E', '6F'];
  public form_class: string[] = [...this.formClassOptions];

  constructor(public route: ActivatedRoute,
              public router: Router,
              public appGlobal: AppGlobal,
              public _location: Location,
              public schoolService: SchoolService,
              public academicService: AcademicService) {
    super(route, router, appGlobal, _location);
    this.loadYears();
    this.loadSchools();
  }

  loadYears() {
    this.academicService.findAll({ '$orderby': 'from_time desc' }).then(res => {
      if (res && !res.error) {
        this.academicYears = res.map(item => ({value: item.academic_year_id, label: item.academic_year_id}));

        if (!this.selectedYear) {
          this.selectedYear = this.academicYears[0].value;
        }
      }
    });
  }

  loadSchools() {
    const condition: any = {};
    if (this.isSuperAdmin() || this.isSystemAdmin()) {
      condition.$orderby = 'code';
    } else {
      condition.school_id = this.appGlobal.refer_schoolCurrentUserLogin || this.appGlobal.schoolCurrentUserLogin;
    }
    return this.schoolService.findAll(condition).then(res => {
      if (res && !res.error) {
        this.originSchools = res;
        this.listSchools =
          res.map(item => ({value: item.id, label: item.code}));
        if (this.selectedSchools.length === 0 && res.length > 0) {
          this.selectedSchools.push(res[0].school_id);
        }
        this.changeSchoolTitleSelection();
      }
    });
  }

  changeSchoolSelection() {
    this.resetSequence();
    this.changeSchoolTitleSelection();
    this.buildUrl();
  }

  buildUrl() {}

  changeSchoolTitleSelection() {
    if (!this.selectedSchools) {
      this.selectedSchools = [];
    }
    this.placeHolderSchool = '';
    if (this.selectedSchools.length === 1) {
      this.defaultSchoolText = 'School (' + GlobalFunction.getLabelFromArrayByKey(this.selectedSchools[0], this.listSchools) + ')';
    } else if (this.selectedSchools.length > 1 && this.selectedSchools.length < this.listSchools.length) {
      this.defaultSchoolText = 'School (' + this.selectedSchools.length + ')';
    } else if (this.listSchools.length !== 0 && this.selectedSchools.length === this.listSchools.length) {
      this.defaultSchoolText = 'School (All)';
    } else {
      this.defaultSchoolText = 'School';
      this.placeHolderSchool = 'School';
    }
  }

  resetSequence() {
    this.idMap = [];
    this.sequenceNo = 0;
  }

  onTimePeriodChange() {
    this.buildUrl();
  }

  onFormClassChange() {
    if (this.form_class.includes('All')) {
      if (this.selectedAllFormClass) { // Before state = true
        this.form_class = this.form_class.filter(item => item !== 'All'); // Unchecked all option
        this.selectedAllFormClass = false;
      } else {
        this.form_class = [...this.formClassOptions];
        this.selectedAllFormClass = true;
      }
    } else if (!this.form_class.includes('All') && this.selectedAllFormClass) {
      this.form_class = [];
      this.selectedAllFormClass = false;
    } else if (!this.form_class.includes('All') && !this.selectedAllFormClass
      && this.form_class.length === this.formClassOptions.length - 1) {
      this.form_class = [...this.formClassOptions];
      this.selectedAllFormClass = true;
    }
    this.placeHolderFormClass = '';
    if (this.form_class.length >= 1 && this.form_class.length < this.formClassOptions.length){
      this.defaultFormClass = 'Form/Class (' + this.form_class.length + ')';
    } else if (this.form_class.length !== 0 && this.form_class.length === this.formClassOptions.length) {
      this.defaultFormClass = 'All';
    } else {
      this.defaultFormClass = 'Form/Class';
      this.placeHolderFormClass = 'Form/Class';
    }

    if (this.selectedAllFormClass && this.formClassSelection) {
      this.formClassSelection.close();
    }
    this.buildUrl();
  }

  onYearChange() {
    this.buildUrl();
  }

  clickToots() {
    const params = {academic_year_id: this.selectedYear,
      'school_id': this.selectedSchools.join(',')};
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/tools', params]);
  }

  changeTab(tabIndex: number) {
    this.activePage = tabIndex;
    if (tabIndex === 1) { // if select record tab, re-call api to load new data
      this.loadRecordTab();
    }
  }

  loadRecordTab() {}

  copyToClipboard(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}



// WEBPACK FOOTER //
// ./src/app/application/admin-table-evaluation-base.component.ts